<template>
  <div class="important-info-popup">
    <div class="important-info-popup-shadow" @click="$emit('close')"></div>

    <div class="important-info-popup-inner">
      <div class="important-info-header">
        <p class="important-info-popup-title">{{  localizeList.importantInfo }}</p>
        <div>
          <div class="important-info-popup-close" @click="$emit('close')"></div>
        </div>
      </div>

      <div class="important-info-popup-wrapper">
        <div class="important-info-popup-description">
          <div class="important-info-section">

            <!-- Для детей -->
            <template v-if="hasChildren">
              <p class="important-info-section-title">{{ localizeList.policyBlockForChildren }}</p>

              <div class="policy-block" v-if="MetapolicyExtraInfo.children.length">
                <div class="policy-block-title">{{ localizeList.policyBlockChildren }}</div>

                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockChildrenAcc }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr v-for="(item, idx) in getChildren(MetapolicyExtraInfo.children)" :key="idx">
                      <td>{{ item.ageString }}</td>
                      <td>{{  item.fullString }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div class="policy-block" v-if="MetapolicyExtraInfo.children_meal.length">
                <div class="policy-block-title">{{ localizeList.policyBlockMealsForChildren }}</div>

                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockMealType }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr
                      v-for="(item, idx) in getChildrenMeal(
                        MetapolicyExtraInfo.children_meal
                      )"
                      :key="idx"
                    >
                      <td>{{ item.mealTypeString }}</td>
                      <td>{{ item.fullString }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="policy-block" v-if="MetapolicyExtraInfo.cot.length">
                <div class="policy-block-title">{{ localizeList.policyBlockCot }}</div>

                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockMaxCount }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr v-for="(item, idx) in getCot(MetapolicyExtraInfo.cot)" :key="idx">
                      <td>{{ item.amountString }}</td>
                      <td>{{ item.fullString }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

             <!-- Интернет -->
             <template v-if="MetapolicyExtraInfo.internet.length">
              <p class="important-info-section-title">{{ localizeList.policyBlockInternet }}</p>

              <div class="policy-block">
                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockLocation }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr
                      v-for="(item, idx) in getInternet(MetapolicyExtraInfo.internet)"
                      :key="idx"
                    >
                      <td>{{ item.internetString }}</td>
                      <td>{{ item.fullString }}</td> 
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

             <!-- Депозит -->
             <template v-if="MetapolicyExtraInfo.deposit.length">
              <p class="important-info-section-title">{{ localizeList.policyBlockDeposit }}</p>

              <div class="policy-block">
                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockDepositType }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr
                      v-for="(item, idx) in getDepositBlock(MetapolicyExtraInfo.deposit)"
                      :key="idx"
                    >
                      <td>{{ item.depositString }}</td>
                      <td>{{ item.fullString }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

             <!-- Условия проживания -->
            <template v-if="hasAccomodations">
              <p class="important-info-section-title">{{ localizeList.policyBlockAccommodations }}</p>

              <div class="policy-block" v-if="MetapolicyExtraInfo.extra_bed.length">
                <div class="policy-block-title">{{ localizeList.policyBlockExtraBed }}</div>

                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockMaxCount }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr
                      v-for="(item, idx) in getExtraBed(MetapolicyExtraInfo.extra_bed)"
                      :key="idx"
                    >
                      <td>{{ item.amount }}</td>
                      <td>{{ item.fullString }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="policy-block" v-if="MetapolicyExtraInfo.meal.length">
                <div class="policy-block-title">{{ localizeList.policyBlockMeal }}</div>

                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockMealType }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr
                      v-for="(item, idx) in getMeal(MetapolicyExtraInfo.meal)"
                      :key="idx"
                    >
                      <td>{{ item.mealTypeString }}</td>
                      <td>{{ item.fullString }}</td> 
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

            <!-- Парковка -->
            <template v-if="MetapolicyExtraInfo.parking.length">
              <p class="important-info-section-title">{{ localizeList.policyBlockParking }}</p>

              <div class="policy-block">
                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockLocation }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr
                      v-for="(item, idx) in getParking(MetapolicyExtraInfo.parking)"
                      :key="idx"
                    >
                      <td>{{ item.territoryString }}</td>
                      <td>{{ item.fullString }}</td> 
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

            <!-- Доп.услуги -->
            <template v-if="MetapolicyExtraInfo.add_fee.length">
              <p class="important-info-section-title">{{ localizeList.policyBlockAddFee }}</p>

              <div class="policy-block">
                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockService }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr
                      v-for="(item, idx) in getAddFee(MetapolicyExtraInfo.add_fee)"
                      :key="idx"
                    >
                      <td>{{ item.feeTypeString }}</td>
                      <td>{{ item.fullString }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

            <!-- Трансфер -->
            <template v-if="MetapolicyExtraInfo.shuttle.length">
              <p class="important-info-section-title">{{ localizeList.policyBlockShuttle }}</p>

              <div class="policy-block">
                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockDirection }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr
                      v-for="(item, idx) in getShuttle(MetapolicyExtraInfo.shuttle)"
                      :key="idx"
                    >
                      <td>{{ item.destinationString }}</td>
                      <td>{{ item.fullString }}</td> 
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

            <!-- Проживание с животными  -->
            <template v-if="MetapolicyExtraInfo.pets.length">
              <p class="important-info-section-title">{{ localizeList.policyBlockAccWithPets }} </p>

              <div class="policy-block">
                <table class="policy-block-table">
                  <tbody>
                    <tr>
                      <th>{{ localizeList.policyBlockAvailability }}</th>
                      <th>{{ localizeList.policyBlockPrice }}</th>
                    </tr>

                    <tr
                      v-for="(item, idx) in getPets(MetapolicyExtraInfo.pets)"
                      :key="idx"
                    >
                      <td>{{ item.petsTypeString }}</td>
                      <td>{{ item.fullString }}</td> 
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

            <!-- Виза -->
            <template v-if="showVisaBlock">
              <p class="important-info-section-title">{{  localizeList.policyVisaInfo }}</p>
              <div class="policy-block">
                <p class="extra-info">{{  localizeList.policyVisaDescription }}</p>
              </div>
            </template>

            <!-- Дополнительная информация -->
            <template v-if="MetapolicyExtraInfo.MetapolicyExtraInfo">
              <p class="important-info-section-title">{{  localizeList.additionalInfo }}</p>
              <div class="policy-block">
                <p class="extra-info">{{ MetapolicyExtraInfo.MetapolicyExtraInfo  }}</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "policy-info-popup",

  props: {
    MetapolicyExtraInfo: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    hasChildren(){
      const children = this.MetapolicyExtraInfo.children.length
      const children_meal = this.MetapolicyExtraInfo.children_meal.length
      const cot = this.MetapolicyExtraInfo.cot.length
      return children || children_meal || cot
    },
    hasAccomodations(){
      const extra_bed = this.MetapolicyExtraInfo.extra_bed.length
      const meal = this.MetapolicyExtraInfo.meal.length
      return extra_bed || meal
    },
    showVisaBlock(){
      return this.MetapolicyExtraInfo.visa?.visa_support === 'support_enable'
    },
    priceUnits(){
      return {
        per_room_per_stay: this.localizeList.priceUnitPerRoomPerStay,
        per_room_per_night: this.localizeList.priceUnitPerRoomPerNight,
        per_guest_per_stay: this.localizeList.priceUnitPerGuestPerStay,
        per_guest_per_night: this.localizeList.priceUnitPerGuestPerNight,
        per_guest: this.localizeList.priceUnitPerGuest,
        per_hour: this.localizeList.priceUnitPerHour,
        per_week: this.localizeList.priceUnitPerWeek,
      }
    },
    mealTypes(){
      return {
        unspecified: this.localizeList.needsToBeClarified,
        'all-inclusive': this.localizeList.mealTypeAllInclusive,
        breakfast: this.localizeList.mealTypeBreakfast,
        'breakfast-buffet': this.localizeList.mealTypeBreakfastBuffet,
        'continental-breakfast': this.localizeList.mealTypeContinentalBreakfast,
        dinner: this.localizeList.mealTypeDinner,
        'full-board': this.localizeList.mealTypeFullBoard,
        'half-board': this.localizeList.mealTypeHalfBoard,
        lunch: this.localizeList.mealTypeLunch,
        nomeal: this.localizeList.mealTypeNoMeal,
        'some-meal' : this.localizeList.mealTypeSomeMeal,
        'english-breakfast': this.localizeList.mealTypeEnglishBreakfast,
        'american-breakfast': this.localizeList.mealTypeAmericanBreakfast,
        'asian-breakfast': this.localizeList.mealTypeAsianBreakfast,
        'chinese-breakfast': this.localizeList.mealTypeChineseBreakfast,
        'israeli-breakfast': this.localizeList.mealTypeIsraeliBreakfast,
        'japanese-breakfast': this.localizeList.mealTypeJapaneseBreakfast,
        'scandinavian-breakfast': this.localizeList.mealTypeScandinavianBreakfast,
        'scottish-breakfast': this.localizeList.mealTypeScottishBreakfast,
        'breakfast-for-1': this.localizeList.mealTypeBreakfastFor1,
        'breakfast-for-2': this.localizeList.mealTypeBreakfastFor2,
        'supel-all-inclusive': this.localizeList.mealTypeSuperAllInclusive,
        'soft-all-inclusive': this.localizeList.mealTypeSoftAllInclusive,
        'ultra-all-inclusive': this.localizeList.mealTypeUltraAllInclusive,
        'half-board-lunch': this.localizeList.mealTypeHalfBoardLunch,
        'half-board-dinner' : this.localizeList.mealTypeHalfBoardDinner
      }
    },
  },

  methods: {
    getChildren(value){
      if (!value || !value.length) return;

      const modifiedItems = value.map((el) => {
        const title = this.localizeList.policyBlockChildrenTitle
        const ageString = title.replace("{0}", String(el.age_start)).replace("{1}", String(el.age_end))
        const fullString = el.extra_bed === 'unspecified' || !parseInt(el.price) ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency}`;

        return { ...el, ageString, fullString };
      });

      return modifiedItems
    },

    getChildrenMeal(value) {
      if (!value || !value.length) return;

      const modifiedItems = value.map((el) => {
        const mealTypeString = this.mealTypes[el.meal_type] || el.meal_type;
        const fromGuest = this.localizeList.childrenMealFromGuest;
        const title = this.localizeList.childrenMealTitle
          .replace("{0}", String(el.age_start))
          .replace("{1}", String(el.age_end));
        const fullString = !parseInt(el.price) ? `${this.localizeList.forFree} ${title}` : el.inclusion === 'unspecified' || !el.currency ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency} ${fromGuest} ${title}`;

        return { ...el, mealTypeString, fullString };
      });

      return modifiedItems;
    },

    getCot(value){
      if (!value || !value.length) return;

      const modifiedItems = value.map((el) => {
        const amountString = el.amount || this.localizeList.needsToBeClarified
        const priceUnitString = this.priceUnits[el.price_unit] || "";
        const fullString = !parseInt(el.price) ? this.localizeList.forFree : el.inclusion === 'unspecified' || !el.currency ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency} ${priceUnitString}`
        return { ...el, fullString, amountString };
      });

      return modifiedItems
    },

    getInternet(value){
      if (!value || !value.length) return;

      const workArea = {
        room: this.localizeList.workAreaRoom,
        hotel: this.localizeList.workAreaHotel,
      }

      const internetType = {
        wireless: this.localizeList.internetTypeWireless,
        wired: this.localizeList.internetTypeWired,
      }

      const modifiedItems = value.map((el) => {
        const workAreaString = workArea[el.work_area] || '-'
        const internetTypeString = internetType[el.internet_type] || ""
        const internetString = internetTypeString ? `${workAreaString} (${internetTypeString})` : workAreaString
        const priceUnitString = this.priceUnits[el.price_unit] || this.priceUnits.per_guest;
        const fullString = !parseInt(el.price) ? this.localizeList.forFree : el.inclusion === 'unspecified' || !el.currency ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency} ${priceUnitString}`
        return { ...el, internetString, fullString };
      });

      return modifiedItems
    }, 

    getDepositBlock(value) {
      if (!value || !value.length) return;

      const depositType = {
        keys: this.localizeList.depositTypeKeys,
        pet: this.localizeList.depositTypePet,
        breakage: this.localizeList.depositTypeBreakage,
      };

      const paymentType = {
        card: this.localizeList.paymentTypeCard,
        cash: this.localizeList.paymentTypeCash,
      };

      const modifiedItems = value.map((el) => {
        const paymentString = paymentType[el.payment_type] || "";
        const depositString = depositType[el.deposit_type] || "-";
        const priceUnitString = this.priceUnits[el.price_unit] || this.priceUnits.per_guest;
        const fullString = !parseInt(el.price) ? this.localizeList.forFree : el.availability === "unspecified " ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency} ${paymentString} ${priceUnitString}`
        return { ...el, depositString, fullString };
      });

      return modifiedItems;
    },

    getAddFee(value) {
      if (!value || !value.length) return;

      const feeTypes = {
        unspecified: this.localizeList.feeTypeUnspecified,
        television: this.localizeList.feeTypeTelevision,
        bed_linen: this.localizeList.feeTypeBedLinen,
        towels_only: this.localizeList.feeTypeTowelsOnly,
        conditioning: this.localizeList.feeTypeConditioning,
        refrigerator: this.localizeList.feeTypeRefrigerator,
        microwave: this.localizeList.feeTypeMicrowave,
        towels: this.localizeList.feeTypeTowels,
        housekeeping: this.localizeList.feeTypeHousekeeping,
        heating: this.localizeList.feeTypeHeating,
        utility: this.localizeList.feeTypeUtility,
        safe: this.localizeList.feeTypeSafe,
        luggage_storage: this.localizeList.feeTypeLuggageStorage,
        tour_guide: this.localizeList.feeTypeTourGuide,
        bicycle_rental: this.localizeList.feeTypeBicycleRental,
        baby_highchair: this.localizeList.feeTypeBabyHighchair,
        luggage_storage_apartment: this.localizeList.feeTypeLuggageStorageApartment,
        luggage_storage_office: this.localizeList.feeTypeLuggageStorageOffice
      };

      const modifiedItems = value.map((el) => {
        const priceUnitString = this.priceUnits[el.price_unit] || this.priceUnits.per_guest;
        const feeTypeString = feeTypes[el.fee_type];
        const fullString = parseInt(el.price) ? `${el.price} ${el.currency} ${priceUnitString}` : this.localizeList.forFree;

        return { ...el, feeTypeString, fullString };
      });

      return modifiedItems;
    },
    
    getExtraBed(value) {
      if (!value || !value.length) return;

      const modifiedItems = value.map((el) => {
        const priceUnitString = this.priceUnits[el.price_unit] || this.priceUnits.per_guest;
        const fullString = !parseInt(el.price) ? this.localizeList.forFree : el.inclusion === 'unspecified' || !el.currency ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency} ${priceUnitString}`
        return { ...el, fullString };
      });

      return modifiedItems;
    },
    
    getMeal(value){
      if (!value || !value.length) return;

      const modifiedItems = value.map((el) => {
        const mealTypeString = this.mealTypes[el.meal_type] || el.meal_type;
        const priceUnitString = this.priceUnits[el.price_unit] || this.priceUnits.per_guest;
        const fullString = !parseInt(el.price) ? this.localizeList.forFree : el.inclusion === 'unspecified' || !el.currency ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency} ${priceUnitString}`
        return { ...el, mealTypeString, fullString };
      });

      return modifiedItems
    },

    getParking(value){
      if (!value || !value.length) return;

      const territoryTypes = {
        unspecified: this.localizeList.needsToBeClarified, 
        on_side: this.localizeList.territoryTypeOnside,
        off_side: this.localizeList.territoryTypeOffside,
      }

      const modifiedItems = value.map((el) => {
        const territoryString = territoryTypes[el.territory_type] || el.territory_type;
        const priceUnitString = this.priceUnits[el.price_unit] || el.price_unit;
        const fullString = !parseInt(el.price) ? this.localizeList.forFree : el.inclusion === 'unspecified' || !el.currency ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency} ${priceUnitString}`
        return { ...el, territoryString, fullString };
      });

      return modifiedItems
    },

    getShuttle(value){
      if (!value || !value.length) return;

      const destinationTypes = {
        train: this.localizeList.destinationTypeTrain,
        airport: this.localizeList.destinationTypeAirport,
        airport_train: this.localizeList.destinationTypeAirportTrain,
        ship: this.localizeList.destinationTypeShip
      }

      // const shuttleTypes = {
      //   unspecified: "",
      //   one_way: this.localizeList.shuttleTypeOneWay,
      //   two_ways: this.localizeList.shuttleTypeTwoWays,
      // }

      const modifiedItems = value.map((el) => {
        const destinationType = destinationTypes[el.destination_type] || '-'
        const destinationString = destinationType;
        const fullString = !parseInt(el.price) ? this.localizeList.forFree : el.inclusion === 'unspecified' || !el.currency ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency}`
        return { ...el, destinationString, fullString };
      });

      return modifiedItems
    },

    getPets(value){
      if (!value || !value.length) return;

      const petsPriceUnits = {
        per_guest_per_stay: this.localizeList.priceUnitPetsPerGuestPerStay,
        per_guest_per_night: this.localizeList.priceUnitPetsPerGuestPerNight,
        per_room_per_night: this.localizeList.priceUnitPerRoomPerNight,
        per_room_per_stay: this.localizeList.priceUnitPerRoomPerStay,
        per_hour: this.localizeList.priceUnitPerHour,
        per_week: this.localizeList.priceUnitPerWeek
      }

      const petsType = {
        unspecified: this.localizeList.petsTypeUnspecified,
        gt_5kg: this.localizeList.petsTypeGt5kg,
        lt_5kg: this.localizeList.petsTypeLt5kg,
      }

      const modifiedItems = value.map((el) => {
        const petsTypeString = petsType[el.pets_type] || el.pets_type;
        const priceUnitString = petsPriceUnits[el.price_unit] || el.price_unit;
        const fullString = !parseInt(el.price) ? this.localizeList.forFree : el.inclusion === 'unspecified' || !el.currency ? this.localizeList.needsToBeClarified : `${el.price} ${el.currency} ${priceUnitString}`
        return { ...el, petsTypeString, fullString };
      });

      return modifiedItems
    },
  },
};
</script>

<style scoped>

.important-info-popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 23;
}

.important-info-popup-close {
  position: relative;
  cursor: pointer; 
  margin-right: 20px;
}

.important-info-popup-close:before, .important-info-popup-close:after  {
  content: ""; 
  position: absolute; 
  width: 24px; 
  height: 4px; 
  background: gray;
}

.important-info-popup-close:before {
  transform: rotate(45deg)
}

.important-info-popup-close:after {
  transform: rotate(-45deg);
}

.important-info-header {
  position: sticky;
  top: 0;
  padding: 20px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.important-info-popup-shadow {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-color: rgba(45, 49, 55, 0.4);
}

.important-info-popup-wrapper {
  padding: 0 20px;
}

.important-info-popup-inner {
  position: relative;
  z-index: 10;
  background-color: white;
  max-height: 72vh;
  max-width: 880px;
  border-radius: 6px;
  overflow-y: scroll;
}

.important-info-popup-title {
  font-size: 24px;
}

.important-info-section-title {
  padding: 20px;
  font-size: 20px;
  font-weight: 500;
  background: #319ae645;
}

.policy-block {
  padding-top: 16px;
  padding-bottom: 20px;
}

.policy-block tr:nth-child(2n) {
  background-color: #319ae612;
}

.policy-block:not(:last-child) {
  border-bottom: 1px solid #0000003b;
}

.policy-block-title {
  font-weight: 500;
  font-size: 18px;
  padding-left: 12px;
  margin-bottom: 10px;
}

.policy-block-table {
  width: 100%;
}

.policy-block-table th {
  padding: 8px 12px;
  font-weight: 400;
  text-align: left;
  color: grey;
}

.policy-block-table td {
  width: 50%;
  padding: 8px 45px 8px 12px;
  vertical-align: top;
}

.extra-info {
  padding: 8px 12px;
}

</style>
